import Language from '../Language'

export default new Language(
    'Euskera',
    ['Urtarrila','Otsaila','Martxoa','Apirila','Maiatza','Ekaina','Uztaila','Abuztua','Iraila','Urria','Azaroa','Abendua'],
    ['Urt','Ots','Mar','Api','Mai','Eka','Uzt','Abu','Ira','Urr','Aza','Abe'],
    ['iga','asl','asr','asz','osg','osl','lar'],
)
// eslint-disable-next-line
;


